import { useQuery } from '@tanstack/react-query';

import { getReportRun, getReportRuns } from '../api/build-a-dash-api';
import type { ReportRun } from '../components/Reports/types';

export const reportRunQueryKeys = {
  all: ['reportRuns'],
  lists: () => [...reportRunQueryKeys.all, 'list'],
  list: (ownerId: string) => [...reportRunQueryKeys.lists(), { ownerId }],
  details: () => [...reportRunQueryKeys.all, 'detail'],
  detail: (runId: string) => [...reportRunQueryKeys.details(), runId],
};

export function useReportRunsQuery(ownerId: string, enabled = true) {
  return useQuery<ReportRun[]>({
    queryKey: reportRunQueryKeys.list(ownerId),
    queryFn: () => getReportRuns(ownerId) as unknown as Promise<ReportRun[]>,
    enabled: Boolean(enabled && ownerId),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}

export function useReportRunQuery(runId: string, enabled = true) {
  return useQuery<ReportRun>({
    queryKey: reportRunQueryKeys.detail(runId),
    queryFn: () => getReportRun(runId),
    enabled: Boolean(enabled && runId),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
